import CardInfoGroup from './CardInfoGroup'

export default CardInfoGroup